import { render } from "./DohBlocking.vue?vue&type=template&id=58db7fb4&scoped=true"
import script from "./DohBlocking.vue?vue&type=script&lang=js"
export * from "./DohBlocking.vue?vue&type=script&lang=js"

import "./DohBlocking.vue?vue&type=style&index=0&id=58db7fb4&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58db7fb4"]])

export default __exports__